import {Card, CardContent, CardHeader, CardTitle} from '@orbit-ui/components/card';
import {PageHeader} from '@orbit-ui/components/page-header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@orbit-ui/components/table';

export const EnvironmentsActivityView = () => {
  const activities = [
    {
      id: 1,
      environment: 'Production',
      action: 'Deploy',
      component: 'API Service',
      user: 'John Smith',
      timestamp: '2025-03-31 14:32:00',
    },
    {
      id: 2,
      environment: 'Staging',
      action: 'Update',
      component: 'Web Frontend',
      user: 'Jane Doe',
      timestamp: '2025-03-31 12:15:00',
    },
    {
      id: 3,
      environment: 'Development',
      action: 'Create',
      component: 'Auth Service',
      user: 'Mike Johnson',
      timestamp: '2025-03-31 10:08:00',
    },
  ];

  return (
    <div className="container mx-auto space-y-6 py-6">
      <PageHeader
        title="Environments Activity"
        description="Recent activities across environments"
      />

      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Environment</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Component</TableHead>
                <TableHead>User</TableHead>
                <TableHead>Timestamp</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {activities.map((activity) => (
                <TableRow key={activity.id}>
                  <TableCell>{activity.environment}</TableCell>
                  <TableCell>{activity.action}</TableCell>
                  <TableCell>{activity.component}</TableCell>
                  <TableCell>{activity.user}</TableCell>
                  <TableCell>{activity.timestamp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
